import React, { useState, useEffect } from "react";
import "./available.css";
import Navbar from "../../Dashboard/navbar/nav";
import Sidebar from "../../Dashboard/sidebar/sidebar";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Requests from "../../../API/api";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import Cookies from "js-cookie";
import axios from "axios";
import moment from "moment";
function Available() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [loading, setLoading] = useState(false);
  const [availableJobs, setAvailableJobs] = useState([]);
  // console.log(availableJobs);
  const navigate = useNavigate();

  useEffect(() => {
    const getAllJobs = async () => {
      try {
        setLoading(true);

        const response = await Requests.get("availableorders");

        // console.log(response.data)
        setAvailableJobs(response.data);
        setLoading(false);
      } catch (err) {
        // console.log(err);

        if (err.response.status === 401) {
          toast.error("Not Authorized");
          navigate("/sign-in");
        } else if (err.response.status === 500) {
          toast.error("A problem with our servers, hang on");
        }
      } finally {
        setLoading(false);
      }
    };

    getAllJobs();
  }, []);

  const [countData, setcountData] = useState({});

  useEffect(() => {
    const DataCount = async () => {
      try {
        const response = await Requests.get("getAllOrderCounts");
        // console.log(response.data)
        setcountData(response.data);
      } catch (err) {
        // console.log(err)
      }
    };

    DataCount();
  }, []);

  // PAGINATION

  const [currentPage, setCurrentPage] = useState(1);
  const [jobsPerPage] = useState(10);

  // Get current jobs
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = availableJobs.slice(indexOfFirstJob, indexOfLastJob);

  // Change page
  const nextPage = () => setCurrentPage(currentPage + 1);
  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const formatDeadline = (deadline) => {
    const now = moment();
    const end = moment(deadline);
    const duration = moment.duration(end.diff(now));
    const hours = Math.floor(duration.asHours());
    const minutes = Math.floor(duration.minutes());
    return `${hours} hours ${minutes} minutes`;
  };

  return (
    <>
      <Navbar toggleSidebar={toggleSidebar} />

      <main className="main-dashboard">
        <div className={`sidebar-render ${isSidebarOpen ? "open" : ""}`}>
          <Sidebar isOpen={isSidebarOpen} sidebarData={countData} />
        </div>

        <div className="dashboard-render">
          <div className="dashboard-render-container available-jobs">
            <p
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "21px",
                marginTop: "20px",
              }}
            >
              Available Gigs
            </p>
            <div class="table-container">
              <table class="responsive-table">
                <thead>
                  <tr>
                    <th>Gig Name</th>
                    <th>Budget</th>
                    <th>Deadline</th>
                    <th>Category</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center" }}>
                        <AiOutlineLoading3Quarters className="loading-icon" />
                      </td>
                    </tr>
                  ) : currentJobs.length === 0 ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center" }}>
                        <p>There are no Gigs at the Moment</p>
                      </td>
                    </tr>
                  ) : (
                    currentJobs.map((jobs) => (
                      <Link
                        to={`/job-description/${jobs._id}`}
                        className="table-link"
                        key={jobs._id}
                      >
                        <tr>
                          <td style={{ fontWeight: "600" }}>
                            {jobs ? jobs.title : "Gig"}
                          </td>
                          <td style={{ color: "green", fontWeight: "600" }}>
                            ${jobs ? jobs.writerbudget : "0"}
                          </td>
                          <td style={{ color: "red", fontWeight: "600" }}>
                            {jobs
                              ? formatDeadline(jobs.deadline)
                              : "No deadline"}
                          </td>
                          <td style={{ fontWeight: "600" }}>
                            {jobs ? jobs.category : "AI-Training"}
                          </td>
                        </tr>
                      </Link>
                    ))
                  )}
                </tbody>
              </table>
              <div className="pagination">
                <MdKeyboardDoubleArrowLeft
                  className={`pagination-icon ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                  onClick={prevPage}
                />
                <span className="pagination-number">{currentPage}</span>
                <MdKeyboardDoubleArrowRight
                  className={`pagination-icon ${
                    currentJobs.length < jobsPerPage ? "disabled" : ""
                  }`}
                  onClick={nextPage}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Available;
